import type { WithActiveBranchId } from '@app/api/shared';

export enum ClientRemindersEndpoints {
  GetClientReminders = 'GetClientReminders',
  SetClientReminders = 'SetClientReminders',
  DeleteClientReminders = 'DeleteClientReminders',
  DisableAllClientReminders = 'DisableAllClientReminders',
  AttachFiles = 'AttachFiles',
  RemoveFiles = 'RemoveFiles',
  GetFiles = 'GetFiles',
}

export interface ModelFile {
  Id: number;
  Name: string | null;
  Data: string | null;
  Lifetime: string | null;
  Description: string | null;
}

export interface SocialIntegrationModelItem {
  Id: number;
  IdS: string | null;
  Name: string | null;
  BranchId: number | null;
  BranchName: string | null;
  SocialType: string | null;
}

export interface ModelBranchReminderIntegration {
  Id: number;
  Order: number;
}

export interface ModelClientReminder {
  Id: number;
  IsOn: boolean;
  ReminderType: string | null;
  ReminderMinutes: number;
  Text: string | null;
  FileIds: number[] | null;
  SendByAllIntegrations: boolean;
}

export interface ModelBranchClientReminders {
  AllowedIntegrations: SocialIntegrationModelItem[] | null;
  DefaultIntegrations: ModelBranchReminderIntegration[] | null;
  SendByAllIntegrations: boolean;
  SendByLastActiveIntegration: boolean;
  ClientReminders: ModelClientReminder[] | null;
}

export interface ModelAttachFilesToReminder {
  Id: number;
  Files: ModelFile[] | null;
}

export interface ModelRemoveFilesFromReminder {
  Id: number;
  FileIds: number[] | null;
}

export interface ModelGetReminderFiles {
  Id: number;
  FileIds: number[] | null;
}

export interface ModelFilesByReminder {
  Id: number;
  Files: ModelFile[] | null;
}

export type GetClientRemindersRequest = WithActiveBranchId;

export type SetClientRemindersRequest = WithActiveBranchId<{
  data: ModelBranchClientReminders;
}>;

export type DeleteClientRemindersRequest = WithActiveBranchId;

export type DisableAllClientRemindersRequest = WithActiveBranchId;

export type AttachFilesRequest = WithActiveBranchId<{
  data: ModelAttachFilesToReminder;
}>;

export type RemoveFilesRequest = WithActiveBranchId<{
  data: ModelRemoveFilesFromReminder;
}>;

export type GetFilesRequest = WithActiveBranchId<{
  data: ModelGetReminderFiles;
}>;

export type GetClientRemindersResponse = ModelBranchClientReminders;
export type SetClientRemindersResponse = ModelBranchClientReminders;
export type DeleteClientRemindersResponse = void;
export type DisableAllClientRemindersResponse = void;
export type AttachFilesResponse = ModelClientReminder;
export type RemoveFilesResponse = void;
export type GetFilesResponse = ModelFilesByReminder;
